module.exports = __webpack_public_path__ + "img/copy-04.b5477a17.svg";